import { chakra, defineRecipe } from '@plurall/elo-v3';
import { Link } from '@tanstack/react-router';

const logoLinkRecipe = defineRecipe({
  className: 'logo-link',
  base: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    color: 'text.primary',
    borderRadius: 'shape.4',

    _focusVisible: {
      outline: '2px solid',
      outlineColor: 'action.focus.ring.primary',
      outlineOffset: '2px',
    },

    '& [data-logo-full]': { display: 'none' },
    '& [data-logo-icon]': { display: 'block' },

    '@media screen and (min-width: 769px)': {
      '& [data-logo-full]': { display: 'block' },
      '& [data-logo-icon]': { display: 'none' },
    },
  },
});

export const LogoLinkFactory = chakra(Link, logoLinkRecipe);
